import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { showRequestProductDBModalReducer } from '../../../redux/slices/components/RequestProducts/requestProductsDataSlice'
import { RootState, useAppDispatch } from '../../../redux/store/store'
import SearcherBar from '../../UIcomponents/SearcherBar/SearcherBar'
import "./HeaderProductRequest.css"

const HeaderProductRequest = () => {

    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const searchBarRef = useRef()

    const typeProduct = useSelector((state: RootState) => state.requestProductsData.typeProduct)

    const searchSubmit = useCallback(
        () => {
            
        },
        [],
    )
    
    const handleRequestProduct = () => {
        dispatch(showRequestProductDBModalReducer())
    }


    return (
        <div className="flex flex-ai-center">
            <p className="title-screen">{t("ManageProducts:request:label_01")}</p>
            <SearcherBar style={{ flex:1  }} ref={searchBarRef} searchSubmit={searchSubmit} placeholder={t("General:label_029")} />

            <button 
                className="btn-request-product border-color-text border-radius-6 flex flex-ai-center ml-20 pl-12 pr-12 pointer"
                onClick={handleRequestProduct}
            >
                <FontAwesomeIcon icon={faPlus} className="fs-18-vh" />
                <p className="fs-20-vh color-text ml-10">{typeProduct === "DIGITAL" ? t("ManageProducts:request:label_03") : t("ManageProducts:request:label_02")}</p>
            </button> 
            
        </div>
    )
}

export default React.memo( HeaderProductRequest )